import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, propTypes, Field } from 'redux-form';
//
import { TextAreaField } from 'components/FormFields/TextAreaField';
import { Button } from 'components';

@reduxForm({
  form: 'unlinkNotesForm',
})
export class NotesForm extends React.PureComponent {
  static propTypes = {
    ...propTypes,
    notesPlaceholder: PropTypes.string,
  };

  render() {
    const { handleSubmit, notesPlaceholder, hideModal } = this.props;

    return (
      <form
        onSubmit={handleSubmit}
        className="form-tile-with-image mt-10 flex flex-column justify-content-center"
        data-testid="unlink-notes-form"
      >
        <Field
          title="Add reason for unlinking:"
          titleClassName="fs-12 form-fields__description _light _not-font"
          name="note"
          placeholder={notesPlaceholder}
          component={TextAreaField}
          maxLength={1000}
        />
        <div className="mt-10 flex justify-content-space-between">
          <Button
            testId="confirm-cancel"
            className="mt-15 _simple-red"
            style={{ minWidth: '180px' }}
            onClick={hideModal}
            dataTestId="unlink-notes-form-cancel"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="_red mt-15"
            style={{ width: '180px' }}
            dataTestId="unlink-notes-form-submit"
          >
            Unlink
          </Button>
        </div>
      </form>
    );
  }
}
